function rainbowize_word(...words) {
	let colorSchema = ['#43c3c9','#e82731','#efa8a8',
		'#f8c634','#1cae64','#8d98cc','#ec2c8d',
		'#f99e1d'
	];
	let colorCodes = [...colorSchema, ...colorSchema, ...colorSchema, ...colorSchema, ...colorSchema, ...colorSchema];
	let colorIndex = 0;
	let rainbowWords = {};
	let textArea = document.createElement('textarea');
	for(var i = 0; i < words.length; i++) {
		let rainbowized = "";
		let characters = words[i].split('');
		for(var j = 0; j < characters.length; j++) {
			let letter = characters[j];
			if (letter.trim().length !== 0) {
				textArea.innerText = letter;
				let encodedLetter = textArea.innerHTML;
				rainbowized+= '<span style="color: '+colorCodes[colorIndex]+' !important;">'+encodedLetter+'</span>';
				colorIndex++;
			} else {
				rainbowized+= ' ';
			}
		}
		rainbowWords[words[i]] = rainbowized;
	}
	return rainbowWords;
}